/* eslint-disable import/prefer-default-export */
import type { State } from '@src/redux/configureStore'

import { filter, some, find, isEmpty } from 'lodash'
import { getUserActivityColumns } from '../configurations'
import { createSelector } from 'reselect'
import type { UsageItem } from '@src/redux/reducers/user.usage/default.state'

export const getUsageInfoList = (state: State) =>
  state.userUsage.usageInfoList || ([] as UsageItem[])
export const getSearchField = (state: State) =>
  state.userUsage.tableOptions.searchFields[0] || null

const getFilterColumns = () =>
  filter<{ field?: string; title?: string; isFilterColumn?: boolean }>(
    getUserActivityColumns({}),
    x => x.isFilterColumn
  ).map(col => ({
    value: col.field,
    label: col.title
  }))

export const getFilterColumnsSelector = createSelector(
  [getUsageInfoList, getFilterColumns, getSearchField],
  (usageInfoList, filterColumns, searchField) => {
    const searchFields = filter(filterColumns, col =>
      some(usageInfoList, item => item[col.value])
    )
    const selectedSearchField = find(
      filterColumns,
      col => col.value === searchField
    )
    const selectedSearchFields = !isEmpty(selectedSearchField)
      ? [selectedSearchField]
      : []
    return !isEmpty(searchFields) ? searchFields : selectedSearchFields
  }
)

export const getStartTime = (state: State) => state.userUsage.startTime
export const getEndTime = (state: State) => state.userUsage.endTime
export const getIsPending = (state: State) => state.userUsage.isPending
export const getTableOptions = (state: State) => state.userUsage.tableOptions
export const getLogDetails = (state: State) => state.userUsage.logDetails
